import React from "react";
import { NavLink } from "react-router";

import { useThemingPrefix } from "hooks/useThemingPrefix";

import { Center, SimpleHeader } from "../../components/ui";
import { getRoute, pages } from "../../utils/routrer-utils";

import styles from "./index.module.css";

const NotFoundPage = () => {
  const vendorThemingPrefix = useThemingPrefix();
  return (
    <>
      <SimpleHeader />
      <Center>
        <div className={styles.container}>
          <div className={styles.errorCode}>404</div>
          <div className={styles.message}>Страница не найдена</div>
        </div>
        <div className={styles.homeLink}>
          <NavLink to={getRoute(pages.HOME, vendorThemingPrefix)}>
            Вернуться на главную
          </NavLink>
        </div>
      </Center>
    </>
  );
};

export default NotFoundPage;
